import { Typography } from "@mui/material";
import { MprcLink } from "components/MprcLink";
import { NotificationType } from "generated/CoreApi_v1";
import React, { ReactNode } from "react";
import { Link } from "react-router";
import { FoundationPaths } from "routes/FoundationRouter";
import { LmsPaths } from "routes/LmsRouter";
import { MessengerResolver } from "views/foundation/notification/resolvers/MessengerResolver";
import { OperationMode } from "views/lms/devPlan/Home/Edit/EditDevPlanView/EditDevPlanView";
import { TrainingRegistrationDialog } from "views/lms/student/Registration/TrainingRegistrationDialog";

////////////////////////////////////////////////////////////////////////////////

export class LmsResolver extends MessengerResolver {

    static messengerId: string[] = [
        "Lms.*"
    ];


    protected trainingViewer(): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={`${LmsPaths.BuildTrainingViewer(this.notificationActionKeys![0])}`} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected enrollmentViewer(): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={`${LmsPaths.BuildEnrollmentViewer(this.notificationActionKeys![1], this.notificationActionKeys![0])}`} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected instructorMonitoringViewer(): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={`${LmsPaths.BuildSupervisorClassroom(this.notificationActionKeys![0])}`} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected instructorSupervisor(): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={LmsPaths.SupervisorInstructor} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected coordinatorSupervisor(): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={LmsPaths.SupervisorCoordinator} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected devPlanView(mode: OperationMode): React.ReactNode {
        return <Link key={(new Date()).getDate()} to={LmsPaths.BuildDevPlanView(this.notificationActionKeys![0], mode)} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
            <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
        </Link>;
    }

    protected translateAction(): ReactNode {

        if (this.notification.notificationTypeId == NotificationType.LmsTrainingMandatoryReminder) {
            return <Link key={(new Date()).getDate()} to={LmsPaths.CarouselTrainingMandatory} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
            </Link>;
        }

        if (this.notificationActionKeys == null)
            return this.notificationAction?.title ?? "?";

        switch (this.notification.notificationTypeId) {
            case NotificationType.LmsCertificateCreated:
            case NotificationType.LmsCertificateExpired:
            case NotificationType.LmsCertificateExpiring:
            case NotificationType.LmsEnrollApproved:
            case NotificationType.LmsEnrollCancelled:
            case NotificationType.LmsEnrollCreated:
            case NotificationType.LmsEnrollExtraTimeGiven:
            case NotificationType.LmsEnrollLearnPathRecycling:
            case NotificationType.LmsEnrollCourseRecycling:
            case NotificationType.LmsEnrollReproved:
            case NotificationType.LmsEnrollRevoked:
            case NotificationType.LmsEnrollUndoRevoked:
            case NotificationType.LmsUserEnrolled:
            case NotificationType.LmsWorkflowConclusionFormApproved:
            case NotificationType.LmsWorkflowConclusionFormRejected:
            case NotificationType.LmsWorkflowConclusionFormReproved:
            case NotificationType.LmsTrainingContentChangedStudent:
            case NotificationType.LmsActivityRegisterScore:
            case NotificationType.LmsActivityCancelled:
            case NotificationType.LmsActivityDueDateChanged:
            case NotificationType.LmsActivityWillExpire:
            case NotificationType.LmsMeetingRegisterScore:
            case NotificationType.LmsMeetingCancelled:
            case NotificationType.LmsMeetingCalendarChanged:
            case NotificationType.LmsMeetingRecordingChanged:
            case NotificationType.LmsMeetingRecordingPublished:
            case NotificationType.LmsMeetingStartLong:
            case NotificationType.LmsMeetingStartShort:
            case NotificationType.LmsNotice:
            case NotificationType.LmsDiscussionReplyMentionClassroom:
            case NotificationType.LmsDiscussionMentionEnroller:
            case NotificationType.LmsDiscussionReplyMentionEnroller:
            case NotificationType.LmsTrainingStarted:
            case NotificationType.LmsTrainingReminderContinue:
            case NotificationType.LmsTrainingDueDateEnding:
            case NotificationType.LmsTrainingDelayed:
            case NotificationType.LmsTrainingExpiring:
            case NotificationType.LmsEnrollDeleted:
            case NotificationType.AwardLmsTrainingApproved:
            case NotificationType.AwardLmsTrainingEnrolled:
            case NotificationType.LmsWorkflowPreApprovalApproved:
            case NotificationType.LmsLearnPathNextEnrollAutomatic:
            case NotificationType.LmsLearnPathNextEnrollManual:
            case NotificationType.LmsLearnPathPhaseEnabled:
                return this.enrollmentViewer();

            case NotificationType.LmsUserShareTraining:
            case NotificationType.LmsWorkflowPreApprovalReproved:
            case NotificationType.LmsWorkflowPreApprovalExpired:
                return this.trainingViewer();

            case NotificationType.LmsTrainingAvailable:
                return (
                    <MprcLink
                        color="primary.light"
                        onClick={
                            () => {
                                this.onCloseMenu();
                                this.renderDialog(
                                    <TrainingRegistrationDialog trainingId={this.notificationActionKeys![0]} onClose={() => this.renderDialog(null)} />
                                );
                            }
                        }
                    >
                        {this.notificationAction?.title}
                    </MprcLink>
                );

            case NotificationType.LmsMeetingAddInstructor:
                return <Link key={(new Date()).getDate()} to={LmsPaths.BuildSupervisorMeetingAttendanceList(this.notificationActionKeys![0], this.notificationActionKeys![1])} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
                </Link>;

            case NotificationType.LmsTrainingContentChangedInstructor:
            case NotificationType.LmsTrainingContentChangedCoordinator:
            case NotificationType.LmsTrainingAddCoordinator:
            case NotificationType.LmsTrainingInstructorBlocked:
                return this.coordinatorSupervisor();

            case NotificationType.LmsDiscussionMentionInstructor:
            case NotificationType.LmsDiscussionReplyMentionInstructor:
            case NotificationType.LmsTrainingAddInstructor:
            case NotificationType.LmsClassroomAddInstructor:
                return this.instructorMonitoringViewer();

            case NotificationType.LmsAppointmentConflictCreatedCoordinator:
                return <Link key={(new Date()).getDate()} to={LmsPaths.BuildListInstructorMeetings(this.notificationActionKeys![0])} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
                </Link>;

            case NotificationType.LmsAppointmentConflictCreatedInstructor:
                return <Link key={(new Date()).getDate()} to={LmsPaths.StudentMeetings} title={this.notificationAction?.title} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction?.title ?? "?"}</Typography>
                </Link>;

            case NotificationType.LmsEnrollExempt:
                return (
                    <MprcLink
                        color="primary.light"
                        onClick={
                            () => {
                                this.onCloseMenu();
                                this.renderDialog(
                                    <TrainingRegistrationDialog readonly trainingId={this.notificationActionKeys![0]} onClose={() => this.renderDialog(null)} />
                                );
                            }
                        }
                    >
                        {this.notificationAction?.title}
                    </MprcLink>
                );

            case NotificationType.LmsDevPlanApproved:
            case NotificationType.LmsDevPlanArchived:
            case NotificationType.LmsDevPlanConcluded:
            case NotificationType.LmsDevPlanCreatedManager:
            case NotificationType.LmsDevPlanArchivingSoon:
            case NotificationType.LmsDevPlanCompletionSoon:
            case NotificationType.LmsDevPlanNewDiscussionOwner:
            case NotificationType.LmsDevPlanNewDiscussionManager:
            case NotificationType.LmsDevPlanDiscussionMention:
            case NotificationType.LmsDevPlanChangedByManager:
            case NotificationType.LmsDevPlanChangedByOwner:
            case NotificationType.LmsDevPlanActivityDelayed:
            case NotificationType.LmsDevPlanActivityDeadline:
                return this.devPlanView(OperationMode.View);

            case NotificationType.LmsDevPlanCreatedOwnUser:
                return this.devPlanView(OperationMode.Edit);

            case NotificationType.LmsImportTrainings:
            case NotificationType.LmsImportEnrollments:
                return <Link to={FoundationPaths.BuildLoadData(this.notificationAction!.keys![0])} title={this.notificationAction?.title ?? ""} onClick={() => this.onCloseMenu()}>
                    <Typography variant="linkAction">{this.notificationAction?.title ?? ""}</Typography>
                </Link>;
        }

        return "???";
    }

}
